module.exports = __webpack_public_path__ + "static/media/map.feb5b2eb.webp";